module.exports = require("ethereumjs-vm");